export default __webpack_public_path__ + "static/media/SD-about-srisailam-bg.fe4f64c7.png";